import React from "react"
export function WalletFill(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10 2a8 8 0 110 16 8 8 0 010-16zm1.744 4.572l-.093.003-4.572.51a.572.572 0 00-.5.474l-.008.095v5.203c0 .284.208.52.48.564l.092.008h5.714c.284 0 .52-.208.564-.48l.008-.092v-4a.572.572 0 00-.48-.564l-.092-.007H7.43l-.052-.005a.286.286 0 01-.226-.213L7.143 8l.004-.051c.02-.112.105-.2.214-.227l.068-.008h4.857v-.571a.571.571 0 00-.542-.57zm.542 4a.571.571 0 110 1.142.571.571 0 010-1.143z"
        fill="currentColor"
        id="prefix__wallet---fill"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
